export default __webpack_public_path__ + "static/media/result.d4d15eb2.svg";